import { getProvinceAndCity, getDictionary, getAwards } from '../../../api/api';

const checkQQAndEmail = ((rule, value, callback) => {
    const reg = /^[^\u4e00-\u9fa5]*$/;
    if(value === '') {
        callback(new Error('QQ/邮箱不可为空'));
    }else if(!reg.test(value)) {
        callback(new Error('QQ/邮箱中不可有中文汉字'));
    }else{
        callback();
    }
})

const checkAllStrIsNumber = ((rule, value, callback) => {
    const reg = /^\d*\.?\d+$/;
    let label;
    for(let i = 0; i < rule.dataSource.length; i++) {
        for(let j = 0; j < rule.dataSource[i].content.length; j++) {
            if(rule.field === rule.dataSource[i].content[j].prop) {
                label = rule.dataSource[i].content[j].label
                break;
            }
        }
    }
    if(value === '') {
        callback(new Error(label + '不可为空'));
    }else if(!reg.test(value)) {
        callback(new Error(label + '只能为数字'));
    }else{
        callback();
    }
})

const checkIDcardPhotoUpload = ((rule, value, callback) => {
    let flag = false;
    let index;
    for(let i = 0; i < value.length; i++) {
        if(value[i] === '') {
            flag = true;
            index = i;
            break;
        }
    }
    if(flag && index === 0) {
        callback(new Error('请上传代表设计师身份证正面照片'));
    }else if(flag && index === 1) {
        callback(new Error('请上传代表设计师身份证反面照片'));
    }else if(!flag) {
        callback();
    }
})

const checkAwardsShowAndAwardsExhibition = ((rule, value, callback) => {
    let flag = false;
    let message;
    if(rule.field === 'awards_designer_show') {
        message = '秀'
    }else if(rule.field === 'awards_designer_exhibition') {
        message = '展'
    }
    value.forEach(item => {
        if(item.id !== '') {
            flag = true;
        }
    })
    if(flag) {
        callback();
    }else{
        callback(new Error('最少选择一个参评奖项' + message))
    }
})

const checkServicePriceInterval = ((rule, value, callback) => {
    let interval = rule.data;
    let reg = /^\d*\.?\d+$/;
    if(interval.service_spring_summer === '') {
        callback(new Error('请输入春夏产品价格区间!'))
        return false;
    }else if(interval.service_autumn_winter === '') {
        callback(new Error('请输入秋冬产品价格区间!'))
        return false;
    }
    else if(!reg.test(interval.service_spring_summer) || !reg.test(interval.service_autumn_winter)) {
        callback(new Error('输入的内容只能为数字（包含小数）!'))
        return false;
    }
    else{
        callback();
    }
})

const checkBusinessPriceInterval = ((rule, value, callback) => {
    let interval = rule.data;
    let reg = /^\d*\.?\d+$/;
    if(interval.business_min_price === '') {
        callback(new Error('请输入最小品牌价格！'));
        return false;
    }
    else if(interval.business_max_price === '') {
        callback(new Error('请输入最大品牌价格！'));
        return false;
    }
    else if(!reg.test(interval.business_min_price) || !reg.test(interval.business_max_price)) {
        callback(new Error('输入的内容只能为数字（包含小数）!'))
        return false;
    }
    else if(Number(interval.business_min_price) > Number(interval.business_max_price)) {
        callback(new Error('最小品牌价格不可大于最大品牌价格'))
    }
    else{
        callback();
    }
})

const checkEducation = ((rule, value, callback) => {
    const field = rule.field;
    let str = '';
    if(field === "zhuanke_education") {
        str = '专科'        
    }else if(field === 'benke_education') {
        str = '本科'
    }else if(field === 'yanjiusheng_education') {
        str = '研究生'        
    }else if(field === 'boshi_education') {
        str = '博士'
    }else if(field === 'boshihou_education') {
        str = '博士后'
    }
    if(value.name === '') {
        callback(new Error('请输入' + str + '所在学校名称，若没有则填无'))
        return false;
    } else if(value.name !== '' && value.name !== '无') {
        if(value.url === '') {
            callback(new Error('请上传' + str + '学位证书图片！'))
            return false;
        } else {
            callback()
        }
    }else {
        callback()
    }
})


let getProvinceAndCityData = () => {
    return new Promise(resolve => {
        getProvinceAndCity().then(res => {
            resolve(res);
        })
    })
}

let dictionaryString = '?type=fashion_brand_institution,sex,fashion_brand_publish_num,fashion_brand_attributable,fashion_brand_category,TrueFalse,declare_card_type';
let getDictionaryData = () => {
    return new Promise(resolve => {
        getDictionary(dictionaryString).then(res => {
            resolve(res);
        })
    })
}

let getAwardsData = () => {
    return new Promise(resolve => {
        getAwards().then(res => {
            resolve(res);
        })
    })
}


let setData = () => {
    return Promise.all([getProvinceAndCityData(), getDictionaryData(), getAwardsData()])
    .then(res => {
        let lists = res[2].data.lists;
        let showDataSource = {
            label: '参评奖项秀',
            type: 'flexible',
            width: '100%',
            prop: 'awards_designer_show',
            children: [],
            notDisplaying: false,
        };
        let exhibitionDataSource = {
            label: '参评奖项展',
            type: 'flexible',
            width: '100%',
            prop: 'awards_designer_exhibition',
            children: [],
            notDisplaying: false,
        }
        let showData = [];
        let exhibitionData = [];
        lists.forEach(item => {
            if(item.type == 1) {
                showDataSource.children.push({
                    label: item.name,
                    type: 'select',
                    prop: 'awards_designer_show',
                    options: item.children
                })
                showData.push({
                    parent_id: item.id,
                    id: '',
                })
            }else if(item.type == 2) {
                exhibitionDataSource.children.push({
                    label: item.name,
                    type: 'select',
                    prop: 'awards_designer_exhibition',
                    options: item.children
                })
                exhibitionData.push({
                    parent_id: item.id,
                    id: '',
                })
            }
        })
        const data = {
            base_institution: res[1].data.fashion_brand_institution[0].value,
            base_project: [],
            base_company_cn: '',
            base_company_en: '',
            base_person: '',
            base_sex: res[1].data.sex[0].value,
            base_address: '',
            base_detailed_address: '',
            base_introduce: '',
            base_contacts: '',
            base_position: '',
            base_mobile: '',
            base_email: '',
            base_mailing_address: '',
            brand_name_cn: '',
            brand_name_en: '',
            brand_register_place: '',
            brand_publish_num: res[1].data.fashion_brand_publish_num[0].value,
            brand_design_team: '',
            brand_introduce: '',
            brand_attributable: res[1].data.fashion_brand_attributable[0].value,
            brand_category: [],
            designer_name_cn: '',
            designer_name_en: '',
            designer_position: '',
            designer_mobile: '',
            designer_card_type: res[1].data.declare_card_type[1].value,
            designer_ID_number: '',
            designer_weibo: '',
            designer_publish_num: res[1].data.fashion_brand_publish_num[0].value,
            designer_introduce: '',
            business_max_price: '',
            business_min_price: '',
            business_self_shop_num: '',
            business_self_shop_sales: '',
            business_self_shop_address: [''],
            business_agent_num: '',
            business_agent_sales: '',
            business_agent_address: [''],
            business_mall_num: '',
            business_mall_sales: '',
            business_mall_address: [''],
            business_showroom_num: '',
            business_showroom_sales: '',
            business_showroom_address: [''],
            business_select_shop_num: '',
            business_select_shop_sales: '',
            business_select_shop_address: [''],
            business_online_num: '',
            business_online_sales: '',
            business_online_address: [''],
            business_year_value: '',
            business_year_sales: '',
            business_pay_taxes: '',
            business_year_growth_rate: '',
            business_year_SKU: '',
            business_delivery_time: '',
            company_other_brand: '',
            company_other_sales: '',
            company_OEM: '',
            company_OEM_sales: '',
            company_design: '',
            company_design_sales: '',
            company_year_value: '',
            company_year_sales: '',
            company_year_pay_taxes: '',
            company_year_growth_rate: '',
            medium_web: '',
            medium_weibo_account: '',
            medium_weibo_fans: '',
            medium_gzh_account: '',
            medium_gzh_fans: '',
            medium_tiktok_account: '',
            medium_tiktok_fans: '',
            medium_xhs_account: '',
            medium_xhs_fans: '',
            medium_other_account: '',
            medium_other_fans: '',
            gen_business_license: '',
            gen_trademark_certificate: '',
            gen_main_designer_ID_card: ['', ''],
            gen_main_designer_qualification: '',
            gen_brand_logo: '',
            gen_tyear_lookbook: '',
            gen_design_concept: '',
            awards_join_evaluation: res[1].data.TrueFalse[0].value,
            awards_designer_show: [], // 在下面动态渲染了值
            awards_designer_exhibition: [], // 在下面动态渲染了值
            awards_designer: '',
            awards_designer_sex: res[1].data.sex[0].value,
            awards_brand: '',
            awards_designer_photo: '',
            awards_designer_trailer: '',
            awards_video: '',
            service_add: res[1].data.TrueFalse[1].value,
            service_exhibition: res[1].data.TrueFalse[1].value,
            service_spring_summer: '',
            service_autumn_winter: '',
            service_lead_time: '',
            zhuanke_education: {
                name: '',
                url: '',
            },
            benke_education: {
                name: '',
                url: '',
            },
            yanjiusheng_education: {
                name: '',
                url: '',
            },
            boshi_education: {
                name: '',
                url: '',
            },
            boshihou_education: {
                name: '',
                url: '',
            },
        }
        const dataSource = [
            {
                title: '企业及品牌相关信息',
                ref: 'enterprise',
                rules: 'enterpriseRules',
                content: [
                    {
                        label: '选择机构',
                        prop: 'base_institution',
                        type: 'radio',
                        children: res[1].data.fashion_brand_institution
                    },
                    {
                        label: '申报项目',
                        prop: 'base_project',
                        type: 'checkbox',
                        children: [
                            {
                                name: '专场发布',
                                value: '专场发布',
                                id: 1
                            },
                        ]
                    },
                    {
                        type: 'empty'
                    },
                    {
                        label: '申报单位（中文）',
                        prop: 'base_company_cn',
                        type: 'text',
                    },
                    {
                        label: '申报单位（English）',
                        prop: 'base_company_en',
                        type: 'text',
                    },
                    {
                        label: '单位负责人',
                        prop: 'base_person',
                        type: 'text',
                    },
                    {
                        label: '性别',
                        prop: 'base_sex',
                        type: 'select',
                        children: res[1].data.sex
                    },
                    {
                        label: '单位所在地址',
                        prop: 'base_address',
                        type: 'cascader',
                        options: res[0].data
                    },
                    {
                        label: '单位详细地址',
                        prop: 'base_detailed_address',
                        type: 'text'
                    },
                    {
                        label: '企业介绍',
                        prop: 'base_introduce',
                        type: 'textarea',
                        placeholder: '200字以内',
                        max_length: '200'
                    },
                    {
                        type: 'title',
                        name: '项目联系人'
                    },
                    {
                        label: '姓名',
                        prop: 'base_contacts',
                        type: 'text'
                    },
                    {
                        label: '职务',
                        prop: 'base_position',
                        type: 'text'
                    },
                    {
                        label: '手机/微信',
                        prop: 'base_mobile',
                        type: 'text'
                    },
                    {
                        label: 'QQ/邮箱',
                        prop: 'base_email',
                        type: 'text'
                    },
                    {
                        label: '邮寄地址',
                        prop: 'base_mailing_address',
                        type: 'text',
                    },
                    {
                        type: 'empty'
                    }
                ], 
            },
            {
                title: '发布品牌',
                ref: 'brand',
                rules: 'brandRules',
                content: [
                    {
                        label: '发布品牌（中文）',
                        prop: 'brand_name_cn',    
                        type: 'text'
                    },
                    {
                        label: '发布品牌（English）',
                        prop: 'brand_name_en',    
                        type: 'text'
                    },
                    {
                        label: '品牌注册地',
                        prop: 'brand_register_place',    
                        type: 'text'
                    },
                    {
                        label: '品牌发布次数',
                        prop: 'brand_publish_num',
                        type: 'radio',
                        children: res[1].data.fashion_brand_publish_num
                    },
                    {
                        label: '品牌设计研发团队人数',
                        prop: 'brand_design_team',    
                        type: 'text',
                        placeholder: '人',
                    },
                    {
                        type: 'empty'
                    },
                    {
                        label: '品牌介绍',
                        prop: 'brand_introduce',
                        type: 'textarea',
                    },
                    {
                        label: '品牌归属',
                        prop: 'brand_attributable',
                        type: 'radio',
                        width: '100%',
                        children: res[1].data.fashion_brand_attributable
                    },
                    {
                        label: '作品类别',
                        prop: 'brand_category',
                        type: 'checkbox',
                        width: '100%',
                        children: res[1].data.fashion_brand_category
                    },
                    {
                        type: 'title',
                        name: '代表设计师'
                    },
                    {
                        label: '姓名',
                        prop: 'designer_name_cn',    
                        type: 'text'
                    },
                    {
                        label: '姓名（English）',
                        prop: 'designer_name_en',    
                        type: 'text'
                    },
                    {
                        label: '职务',
                        prop: 'designer_position',    
                        type: 'text'
                    },
                    {
                        label: '手机/微信',
                        prop: 'designer_mobile',    
                        type: 'text'
                    },
                    {
                        label: '证件类型',
                        prop: 'designer_card_type',
                        type: 'select',
                        children: res[1].data.declare_card_type
                    },
                    {
                        label: '证件号码',
                        prop: 'designer_ID_number',
                        type: 'text'
                    },
                    {
                        label: '微博/ins',
                        prop: 'designer_weibo',    
                        type: 'text'
                    },
                    {
                        label: '设计师发布次数',
                        prop: 'designer_publish_num',
                        type: 'radio',
                        width: '100%',
                        children: res[1].data.fashion_brand_publish_num
                    },
                    {
                        label: '设计师介绍',
                        prop: 'designer_introduce',
                        type: 'textarea',
                    },
                ]
            },
            {
                title: '申报品牌商业信息',
                ref: 'business',
                rules: 'businessRules',
                content: [
                    {
                        label: '品牌价格区间',
                        type: 'interval',
                        prop: 'business_price_interval',
                        children: [
                            {
                                type: 'text',
                                text: ' 元 - ',
                                prop: 'business_min_price'
                            },
                            {
                                type: 'text',
                                text: ' 元',
                                prop: 'business_max_price'
                            }
                        ]
                    },
                    {
                        type: 'empty'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        type: 'text',
                        prop: 'business_self_shop_num',
                        label: '自营店铺',
                        placeholder: '数量'
                    },
                    {
                        type: 'text',
                        prop: 'business_self_shop_sales',
                        label: '自营店铺销售额',
                        placeholder: '销售额（万元）'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        label: '地址',
                        type: 'variable',
                        prop: 'business_self_shop_address',
                        background: '#F6F7F9',
                        width: '100%'
                    },
                    {
                        type: 'text',
                        prop: 'business_agent_num',
                        label: '加盟代理',
                        placeholder: '数量'
                    },
                    {
                        type: 'text',
                        prop: 'business_agent_sales',
                        label: '加盟代理销售额',
                        placeholder: '销售额（万元）'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        label: '地址',
                        type: 'variable',
                        prop: 'business_agent_address',
                        background: '#F6F7F9',
                        width: '100%'
                    },
                    {
                        type: 'text',
                        prop: 'business_mall_num',
                        label: '商场',
                        placeholder: '数量'
                    },
                    {
                        type: 'text',
                        prop: 'business_mall_sales',
                        label: '商场销售额',
                        placeholder: '销售额（万元）'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        label: '地址',
                        type: 'variable',
                        prop: 'business_mall_address',
                        background: '#F6F7F9',
                        width: '100%'
                    },
                    {
                        type: 'text',
                        prop: 'business_showroom_num',
                        label: 'showroom',
                        placeholder: '数量'
                    },
                    {
                        type: 'text',
                        prop: 'business_showroom_sales',
                        label: 'showroom销售额',
                        placeholder: '销售额（万元）'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        label: '地址',
                        type: 'variable',
                        prop: 'business_showroom_address',
                        background: '#F6F7F9',
                        width: '100%'
                    },
                    {
                        type: 'text',
                        prop: 'business_select_shop_num',
                        label: '买手店',
                        placeholder: '数量'
                    },
                    {
                        type: 'text',
                        prop: 'business_select_shop_sales',
                        label: '买手店销售额',
                        placeholder: '销售额（万元）'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        label: '地址',
                        type: 'variable',
                        prop: 'business_select_shop_address',
                        background: '#F6F7F9',
                        width: '100%'
                    },
                    {
                        type: 'text',
                        prop: 'business_online_num',
                        label: '电商',
                        placeholder: '数量'
                    },
                    {
                        type: 'text',
                        prop: 'business_online_sales',
                        label: '电商销售额',
                        placeholder: '销售额（万元）'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        label: '地址',
                        type: 'variable',
                        prop: 'business_online_address',
                        background: '#F6F7F9',
                        width: '100%'
                    },
                    {
                        type: 'title',
                        name: '合计'
                    },
                    {
                        type: 'text',
                        prop: 'business_year_value',
                        label: '品牌年产值',
                        placeholder: '万元'
                    },
                    {
                        type: 'text',
                        prop: 'business_year_sales',
                        label: '品牌年销售额',
                        placeholder: '万元'
                    },
                    {
                        type: 'text',
                        prop: 'business_pay_taxes',
                        label: '品牌纳税额',
                        placeholder: '万元'
                    },
                    {
                        type: 'text',
                        prop: 'business_year_growth_rate',
                        label: '品牌年增长率',
                        placeholder: '%'
                    },
                    {
                        type: 'text',
                        prop: 'business_year_SKU',
                        label: '品牌年度SKU',
                        placeholder: '款'
                    },
                    {
                        type: 'text',
                        prop: 'business_delivery_time',
                        label: '品牌上货期',
                        placeholder: '季'
                    },
                ]
            },
            {
                title: '品牌所属公司信息',
                ref: 'sale',
                rules: 'saleRules',
                content: [
                    {
                        type: 'text',
                        prop: 'company_other_brand',
                        label: '其他品牌（名称）',
                    },
                    {
                        type: 'text',
                        prop: 'company_other_sales',
                        label: '其他品牌（名称）销售额',
                        placeholder: '万元'
                    },
                    {
                        type: 'empty',
                    },
                    {
                        type: 'text',
                        prop: 'company_OEM',
                        label: '贴牌',
                    },
                    {
                        type: 'text',
                        prop: 'company_OEM_sales',
                        label: '贴牌销售额',
                        placeholder: '万元'
                    },
                    {
                        type: 'empty',
                    },
                    {
                        type: 'text',
                        prop: 'company_design',
                        label: '设计服务',
                    },
                    {
                        type: 'text',
                        prop: 'company_design_sales',
                        label: '设计服务销售额',
                        placeholder: '万元'
                    },
                    {
                        type: 'empty',
                    },
                    {
                        type: 'text',
                        prop: 'company_year_value',
                        label: '公司年产值',
                        placeholder: '万元'
                    },
                    {
                        type: 'text',
                        prop: 'company_year_sales',
                        label: '公司年销售额',
                        placeholder: '万元'
                    },
                    {
                        type: 'empty',
                    },
                    {
                        type: 'text',
                        prop: 'company_year_pay_taxes',
                        label: '公司纳税额',
                        placeholder: '万元'
                    },
                    {
                        type: 'text',
                        prop: 'company_year_growth_rate',
                        label: '公司年增长率',
                    },
                    {
                        type: 'empty',
                    },
                ]
            },
            {
                title: '品牌自媒体情况',
                ref: 'media',
                rules: 'mediaRules',
                content: [
                    {
                        type: 'text',
                        prop: 'medium_web',
                        label: '官方网站',
                    },
                    {
                        type: 'empty'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        type: 'text',
                        prop: 'medium_weibo_account',
                        label: '微博账号',
                    },
                    {
                        type: 'text',
                        prop: 'medium_weibo_fans',
                        label: '微博粉丝数量',
                        width: '10%',
                        placeholder: '人'
                    },
                    {
                        type: 'text',
                        prop: 'medium_gzh_account',
                        label: '微信公众号',
                    },
                    {
                        type: 'text',
                        prop: 'medium_gzh_fans',
                        label: '微信公众号粉丝数量',
                        width: '10%',
                        placeholder: '人'
                    },
                    {
                        type: 'text',
                        prop: 'medium_tiktok_account',
                        label: '抖音账号',
                    },
                    {
                        type: 'text',
                        prop: 'medium_tiktok_fans',
                        label: '抖音粉丝数量',
                        width: '10%',
                        placeholder: '人'
                    },
                    {
                        type: 'text',
                        prop: 'medium_xhs_account',
                        label: '小红书账号',
                    },
                    {
                        type: 'text',
                        prop: 'medium_xhs_fans',
                        label: '小红书粉丝数量',
                        width: '10%',
                        placeholder: '人'
                    },
                    {
                        type: 'text',
                        prop: 'medium_other_account',
                        label: '其他平台账号',
                    },
                    {
                        type: 'text',
                        prop: 'medium_other_fans',
                        label: '其他粉丝数量',
                        width: '10%',
                        placeholder: '人'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        type: 'empty',
                        width: '10%'
                    },
                ]
            },
            {
                title: '资料上传/修改',
                ref: 'information',
                rules: 'informationRules',
                content: [
                    {
                        type: 'upload',
                        prop: 'gen_business_license',
                        label: '企业营业执照',
                        tips: '建议JPG、PNG或PDF格式',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'imageText',
                            fileName: '企业营业执照'
                        }
                    },
                    {
                        type: 'upload',
                        prop: 'gen_trademark_certificate',
                        label: '商标证书',
                        tips: '建议JPG、PNG或PDF格式',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'imageText',
                            fileName: '商标证书'
                        }
                    },
                    {
                        type: 'empty'
                    },
                    {
                        type: 'upload',
                        prop: 'gen_main_designer_ID_card',
                        label: '代表设计师身份证',
                        uploadType: 'backgroundImage',
                        uploadFormatValidation: {
                            format: 'imageText',
                            fileName: '',
                        }
                    },
                    {
                        type: 'empty'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        type: 'upload',
                        prop: 'gen_main_designer_qualification',
                        label: '代表设计师学历证',
                        tips: '建议JPG、PNG或PDF格式',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'imageText',
                            fileName: '设计师学历证'
                        }
                    },
                    {
                        type: 'upload',
                        prop: 'gen_brand_logo',
                        label: '品牌LOGO',
                        tips: '建议AI格式',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'AI',
                            fileName: '品牌LOGO'
                        }
                    },
                    {
                        type: 'upload',
                        prop: 'gen_tyear_lookbook',
                        label: '近两年LOOKBOOK及门店照片',
                        tips: '建议PDF格式',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'pdf',
                            fileName: 'LOOKBOOK'
                        }
                    },
                    {
                        type: 'textarea',
                        prop: 'gen_design_concept',
                        label: '本季发布设计理念',
                        placeholder: '请输入本季发布设计理念',
                        max_length: '200'
                    },
                ]
            },
            {
                title: '年度奖项',
                ref: 'awards',
                rules: 'awardsRules',
                content: [
                    {
                        type: 'radio',
                        label: '是否参评',
                        prop: 'awards_join_evaluation',
                        children: res[1].data.TrueFalse,
                        bottomType: 'download',
                        bottomTips: '奖项介绍下载.PDF',
                        bottomStyle: 'color: #E40080;'
                    },
                    {
                        type: 'empty',
                    },
                    {
                        type: 'empty',
                    },
                    {
                        type: 'text',
                        prop: 'awards_designer',
                        label: '设计师',
                        notDisplaying: false,
                    },
                    {
                        type: 'radio',
                        prop: 'awards_designer_sex',
                        label: '设计师性别',
                        children: res[1].data.sex,
                        notDisplaying: false,
                    },
                    {
                        type: 'text',
                        prop: 'awards_brand',
                        label: '品牌',
                        notDisplaying: false,
                    },
                    {
                        type: 'upload',
                        prop: 'awards_designer_photo',
                        label: '设计师形象照',
                        tips: 'JPG高清图片',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'imageText',
                            fileName: '设计师形象照'
                        },
                        notDisplaying: false,
                    },
                    {
                        type: 'upload',
                        prop: 'awards_designer_trailer',
                        label: '宣传大片、产品图片及本季发布效果图',
                        tips: '至少15张,每张不超过5M,建议格式压缩包',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'ZIP',
                            fileName: '宣传大片、产品图片、本季发布效果图'
                        },
                        notDisplaying: false,
                    },
                    {
                        type: 'upload',
                        prop: 'awards_video',
                        label: '产品宣传片',
                        tips: '产品宣传片时长小于1min,格式建议压缩包',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'ZIP',
                            fileName: '视频'
                        },
                        notDisplaying: false,
                    }
                ]
            },
            {
                title: '增值服务',
                ref: 'valueAdd',
                rules: 'valueAddRules',
                content: [
                    {
                        type: 'radio',
                        label: '是否选择媒体增值服务',
                        prop: 'service_add',
                        children: res[1].data.TrueFalse,
                        bottomType: 'tips',
                        bottomTips: '负责媒体同事会主动联系您',
                        bottomStyle: 'color: #FF4D4F;'
                    },
                    {
                        type: 'radio',
                        label: '是否选择DPARK服装服饰ODM展',
                        prop: 'service_exhibition',
                        children: res[1].data.TrueFalse,
                        bottomType: 'tips',
                        bottomTips: '负责展览同事会主动联系您',
                        bottomStyle: 'color: #FF4D4F;'
                    },
                    {
                        type: 'empty'
                    },
                    {
                        label: '主力产品零售价格',
                        type: 'interval',
                        prop: 'service_price_interval',
                        notDisplaying: true,
                        children: [
                            {
                                textInFront: '春夏产品：',
                                type: 'text',
                                text: ' 元  秋冬产品： ',
                                prop: 'service_spring_summer'
                            },
                            {
                                type: 'text',
                                text: ' 元',
                                prop: 'service_autumn_winter'
                            }
                        ]
                    },
                    {
                        label: '增加订货交付时间',
                        type: 'interval',
                        prop: 'service_lead_time',
                        notDisplaying: true,
                        children: [
                            {
                                textInFront: '订单交付周期：',
                                type: 'text',
                                text: '天',
                                prop: 'service_lead_time'
                            }
                        ]
                    },
                    {
                        type: 'empty'
                    },
                ]
            },
            {
                title: '教育经历',
                ref: 'education',
                rules: 'educationRules',
                content: [
                    {
                        type: 'textAndUpload',
                        label: '专科信息',
                        prop: 'zhuanke_education',
                        placeholder: '请输入专科学校名称，没有则填无',
                        tips: '请上传相关学位证书，格式为JPG或PNG',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'imageText',
                            fileName: '专科学历照片'
                        },
                    },
                    {
                        type: 'textAndUpload',
                        label: '本科信息',
                        prop: 'benke_education',
                        placeholder: '请输入本科学校名称，没有则填无',
                        tips: '请上传相关学位证书，格式为JPG或PNG',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'imageText',
                            fileName: '本科学历照片'
                        },
                    },
                    {
                        type: 'textAndUpload',
                        label: '研究生信息',
                        prop: 'yanjiusheng_education',
                        placeholder: '请输入研究生学校名称，没有则填无',
                        tips: '请上传相关学位证书，格式为JPG或PNG',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'imageText',
                            fileName: '研究生学历照片'
                        },
                    },
                    {
                        type: 'textAndUpload',
                        label: '博士信息',
                        prop: 'boshi_education',
                        placeholder: '请输入博士学校名称，没有则填无',
                        tips: '请上传相关学位证书，格式为JPG或PNG',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'imageText',
                            fileName: '博士学历照片'
                        },
                    },
                    {
                        type: 'textAndUpload',
                        label: '博士后信息',
                        prop: 'boshihou_education',
                        placeholder: '请输入博士后学校名称，没有则填无',
                        tips: '请上传相关学位证书，格式为JPG或PNG',
                        uploadType: 'button',
                        uploadFormatValidation: {
                            format: 'imageText',
                            fileName: '博士后学历照片'
                        },
                    },
                    {
                        type: 'empty'
                    }
                ]
            }
        ];
        const dataValidation = {
            enterpriseRules: {
                base_institution: [
                    {
                        required: true,
                        message: '请选择机构',
                        trigger: 'change'
                    }
                ],
                base_company_cn: [
                    {
                        required: true,
                        message: '请输入申报单位名称！',
                        trigger: 'blur'
                    }
                ],
                base_person: [
                    {
                        required: true,
                        message: '请输入单位负责人',
                        trigger: 'blur'
                    }
                ],
                base_sex: [
                    {
                        required: true,
                        message: '请选择性别',
                        trigger: 'change',
                    }
                ],
                base_address: [
                    {
                        required: true,
                        message: '请选择单位所在省市',
                        trigger: 'change'
                    }
                ],
                base_detailed_address: [
                    {
                        required: true,
                        message: '请输入单位所在详细地址',
                        trigger: 'blur'
                    }
                ],
                base_introduce: [
                    {
                        required: true,
                        message: '请输入企业介绍',
                        trigger: 'blur' 
                    }
                ],
                base_contacts: [
                    {
                        required: true,
                        message: '请输入联系人姓名',
                        trigger: 'blur' 
                    }
                ],
                base_position: [
                    {
                        required: true,
                        message: '请输入联系人职务',
                        trigger: 'blur' 
                    },
                ],
                base_mobile: [
                    {
                        required: true,
                        message: '请输入联系人手机/微信',
                        trigger: 'blur' 
                    }
                ],
                base_email: [
                    {
                        required: true,
                        validator: checkQQAndEmail,
                        trigger: 'blur' 
                    }
                ],
                base_mailing_address: [
                    {
                        required: true,
                        message: '请输入联系人邮寄地址',
                        trigger: 'blur' 
                    }
                ]
            },
            brandRules: {
                brand_name_cn: [
                    {
                        required: true,
                        message: '请输入品牌中文名称！',
                        trigger: 'blur'
                    }
                ],
                brand_register_place: [
                    {
                        required: true,
                        message: '请输入品牌注册地！',
                        trigger: 'blur'
                    }
                ],
                brand_publish_num: [
                    {
                        required: true,
                        message: '请选择品牌发布次数！',
                        trigger: 'change'
                    }
                ],
                brand_design_team: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                brand_introduce: [
                    {
                        required: true,
                        message: '请输入品牌介绍',
                        trigger: 'blur'
                    }
                ],
                brand_attributable: [
                    {
                        required: true,
                        message: '请选择品牌归属',
                        trigger: 'change'
                    }
                ],
                brand_category: [
                    {
                        required: true,
                        message: '请选择品牌类别',
                        trigger: 'change'
                    }
                ],
                designer_name_cn: [
                    {
                        required: true,
                        message: '请输入设计师姓名',
                        trigger: 'blur'
                    },
                ],
                designer_name_en: [
                    {
                        required: true,
                        message: '请输入设计师姓名（英文）',
                        trigger: 'blur'
                    }
                ],
                designer_position: [
                    {
                        required: true,
                        message: '请输入设计师职务',
                        trigger: 'blur'
                    }
                ],
                designer_card_type: [
                    {
                        required: true,
                        message: '请选择证件类型',
                        trigger: 'change'
                    }
                ],
                designer_ID_number: [
                    {
                        required: true,
                        validator: ((rule, value, callback) => {
                            console.log(data.designer_card_type)
                            if(data.designer_card_type === '无') {
                                callback();
                            }else if(data.designer_card_type === '居民身份证') {
                                const reg = /^\d{17}[\dXx]$/;
                                if(value === '') {
                                    callback(new Error('身份证号不可为空'));
                                    return false;
                                }else if(!reg.test(value)) {
                                    callback(new Error('身份证号输入格式有误'));
                                    return false;
                                }else{
                                    callback();
                                }
                            }else {
                                const reg = /^[a-zA-Z0-9]*$/;
                                if(value === '') {
                                    callback(new Error('证件号码不可为空'));
                                    return false;
                                }else if(!reg.test(value)) {
                                    callback(new Error('证件号码输入格式有误'));
                                    return false;
                                }else{
                                    callback();
                                } 
                            }
                        }),
                        trigger: 'blur'
                    }
                ],
                designer_mobile: [
                    {
                        required: true,
                        message: '请输入设计师手机/微信',
                        trigger: 'blur'
                    }
                ],
                designer_publish_num: [
                    {
                        required: true,
                        message: '请选择设计师发布次数！',
                        trigger: 'change'
                    }
                ],
                designer_introduce: [
                    {
                        required: true,
                        message: '请输入设计师介绍',
                        trigger: 'blur'
                    }
                ]
            },
            businessRules: {
                business_price_interval: [
                    {
                        required: true,
                        validator: checkBusinessPriceInterval,
                        trigger: 'blur',
                        data
                    }
                ],
                business_self_shop_num: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    },
                ],
                business_self_shop_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_agent_num: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_agent_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_mall_num: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_mall_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_showroom_num: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_showroom_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_select_shop_num: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_select_shop_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_online_num: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_online_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_year_value: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur' ,
                        dataSource
                    }
                ],
                business_year_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur' ,
                        dataSource
                    }
                ],
                business_pay_taxes: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                business_year_growth_rate: [
                    {
                        required: true,
                        message: '请输入品牌年增长率',
                        trigger: 'blur'
                    }
                ],
                business_year_SKU: [
                    {
                        required: true,
                        message: '请输入品牌年度SKU',
                        trigger: 'blur'
                    }
                ],
                business_delivery_time: [
                    {
                        required: true,
                        message: '请输入品牌上货期',
                        trigger: 'blur'
                    }
                ]
            },
            saleRules: {
                company_other_brand: [
                    {
                        required: true,
                        message: '请输入其它品牌名称',
                        trigger: 'blur'
                    }
                ],
                company_other_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                company_OEM: [
                    {
                        required: true,
                        message: '请输入贴牌名称',
                        trigger: 'blur'
                    }
                ],
                company_OEM_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                company_design: [
                    {
                        required: true,
                        message: '请输入设计服务名称',
                        trigger: 'blur'
                    }
                ],
                company_design_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                company_year_value: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                company_year_sales: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                company_year_pay_taxes: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                company_year_growth_rate: [
                    {
                        required: true,
                        message: '请输入公司年增长率',
                        trigger: 'blur'
                    }
                ],
            },
            mediaRules: {
                medium_web: [
                    {
                        required: true,
                        message: '请输入官网地址',
                        trigger: 'blur'
                    }
                ],
                medium_weibo_account: [
                    {
                        required: true,
                        message: '请输入微博账号',
                        trigger: 'blur'
                    }
                ],
                medium_weibo_fans: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                medium_gzh_account: [
                    {
                        required: true,
                        message: '请输入微信公众号',
                        trigger: 'blur'
                    }
                ],
                medium_gzh_fans: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                medium_tiktok_account: [
                    {
                        required: true,
                        message: '请输入抖音账号',
                        trigger: 'blur'
                    }
                ],
                medium_tiktok_fans: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                medium_xhs_account: [
                    {
                        required: true,
                        message: '请输入小红书账号',
                        trigger: 'blur'
                    }
                ],
                medium_xhs_fans: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
                medium_other_account: [
                    {
                        required: true,
                        message: '请输入其它平台账号',
                        trigger: 'blur'
                    }
                ],
                medium_other_fans: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ],
            },
            informationRules: {
                gen_business_license: [
                    {
                        required: true,
                        message: '请上传企业营业执照！',
                        trigger: 'change'
                    }
                ],
                gen_trademark_certificate: [
                    {
                        required: true,
                        message: '请上传商标证书！',
                        trigger: 'change'
                    }
                ],
                gen_main_designer_ID_card: [
                    {
                        required: true,
                        validator: checkIDcardPhotoUpload,
                        trigger: 'change'
                    }
                ],
                gen_main_designer_qualification: [
                    {
                        required: true,
                        message: '请上传设计师学历证！',
                        trigger: 'change'
                    }
                ],
                gen_brand_logo: [
                    {
                        required: true,
                        message: '请上传品牌LOGO！',
                        trigger: 'change'
                    }
                ],
                gen_tyear_lookbook: [
                    {
                        required: true,
                        message: '请上传近两年LOOKBOOK及门店照片！',
                        trigger: 'change'
                    }
                ],
                gen_design_concept: [
                    {
                        required: true,
                        message: '请输入本季发布设计理念！',
                        trigger: 'blur'
                    }
                ]
            },
            awardsRules: {
                awards_join_evaluation: [
                    {
                        required: true,
                        message: '请选择是否参评',
                        trigger: 'change'
                    }
                ],
                awards_designer_show: [
                    {
                        required: true,
                        validator: checkAwardsShowAndAwardsExhibition,
                        trigger: 'change'
                    }
                ],
                // awards_designer_exhibition: [
                //     {
                //         required: true,
                //         validator: checkAwardsShowAndAwardsExhibition,
                //         trigger: 'change'
                //     }
                // ],
                awards_designer: [
                    {
                        required: true,
                        message: '请输入参评设计师姓名',
                        trigger: 'blur'
                    }
                ],
                awards_designer_sex: [
                    {
                        required: true,
                        message: '请选择参评设计师性别',
                        trigger: 'change'
                    }
                ],
                awards_brand: [
                    {
                        required: true,
                        message: '请输入参评品牌名称',
                        trigger: 'blur'
                    }
                ],
                awards_designer_photo: [
                    {
                        required: true,
                        message: '请上传设计师形象照！',
                        trigger: 'change'
                    }
                ],
                // awards_designer_trailer: [
                //     {
                //         required: true,
                //         message: '请上传宣传大片、产品图片及本季发布效果图！',
                //         trigger: 'change'
                //     }
                // ],
                // awards_video: [
                //     {
                //         required: true,
                //         message: '请上传产品宣传片！',
                //         trigger: 'change'
                //     }
                // ]
            },
            valueAddRules: {
                service_add: [
                    {
                        required: true,
                        message: '请选择是否需要媒体增值服务',
                        trigger: 'change'
                    }
                ],
                service_exhibition: [
                    {
                        required: true,
                        message: '请选择是否参加DPARK服装服饰ODM展',
                        trigger: 'change'
                    }
                ],
                service_price_interval: [
                    {
                        required: true,
                        validator: checkServicePriceInterval,
                        trigger: 'blur',
                        data,
                    }
                ],
                service_lead_time: [
                    {
                        required: true,
                        validator: checkAllStrIsNumber,
                        trigger: 'blur',
                        dataSource
                    }
                ]
            },
            educationRules: {
                zhuanke_education: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: checkEducation,
                        data,
                        dataSource
                    }
                ],
                benke_education: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: checkEducation,
                        data,
                        dataSource
                    }
                ],
                yanjiusheng_education: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: checkEducation,
                        data,
                        dataSource
                    }
                ],
                boshi_education: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: checkEducation,
                        data,
                        dataSource
                    }
                ],
                boshihou_education: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: checkEducation,
                        data,
                        dataSource
                    }
                ]
            }
        }
        dataSource.forEach(item => {
            if(item.title === '年度奖项') {
                item.content.splice(3, 0, showDataSource); // 插入参评奖项秀，如需改变其在页面上的位置，更改第一个参数即可
                item.content.splice(4, 0, exhibitionDataSource); // 插入参评奖项展，如需改变其在页面上的位置，更改第一个参数即可
            }
        })
        data.awards_designer_show = showData;
        data.awards_designer_exhibition = exhibitionData;
        return { data, dataSource, dataValidation }
    })
    .catch((res) => {
        console.log('promise出错了')
    })
}  

export { setData };
